import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  CreateTaskRequest,
  Task,
  TaskReduced,
  TasksQuery,
  UpdateAllTaskRequest,
  UpdateTaskRequest,
} from './Tasks.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/tasks`;

export async function listTasks(
  params?: TasksQuery,
): Promise<PageResult<Task>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/filter_pagination`,
    params,
  )) as unknown;

  return result as PageResult<Task>;
}

export async function listTasksReduced(params?: TasksQuery) {
  const result = (await api.get(
    `${CONTROLLER_URL}/filter/reduced`,
    params,
  )) as unknown;

  return result as PageResult<TaskReduced>;
}

export async function getTask(id?: number): Promise<Task> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Task;
}

export async function createTask(obj: CreateTaskRequest): Promise<Task> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Task;
}

export async function updateTask(obj: UpdateTaskRequest) {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Task;
}

export async function updateAllTask(obj: UpdateAllTaskRequest) {
  const result = (await api.put(
    `${API_BASE_URL}/task_prices/all`,
    obj,
    null,
  )) as unknown;

  return result as Task;
}

export async function deleteTask(id: number) {
  const result = await api.remove(`${CONTROLLER_URL}/${id}`, {}, null);

  return result;
}

export async function taskActivateOrInactivate(taskId: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${taskId}/activate`,
    {},
    null,
  )) as unknown;

  return result;
}
